<app-modal [isOpen]="isOpen" (close)="closeModal()" className="max-w-2xl">
  <div class="p-6">
    <div class="mb-5">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white/90">
        Asignar usuarios al número
      </h2>
      @if (phone) {
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {{ phone.displayPhoneNumber }} · {{ phone.verifiedName || 'Sin nombre verificado' }}
        </p>
      }
    </div>

    <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center">
      <input
        type="search"
        [(ngModel)]="searchTerm"
        placeholder="Buscar usuario por nombre o email"
        class="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
      />
      <div class="flex items-center gap-2">
        <label class="text-sm text-gray-700 dark:text-gray-300">Rol:</label>
        <select
          [(ngModel)]="selectedRole"
          class="rounded-lg border border-gray-300 bg-white px-2 py-2 text-sm text-gray-900 focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
        >
          <option value="AGENT">Agente</option>
          <option value="OWNER">Propietario</option>
        </select>
      </div>
    </div>

    @if (successMessage) {
      <div class="mb-3 rounded-lg bg-emerald-50 p-3 text-sm text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300">
        {{ successMessage }}
      </div>
    }

    @if (errorMessage) {
      <div class="mb-3 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-300">
        {{ errorMessage }}
      </div>
    }

    <div class="rounded-lg border border-gray-200 dark:border-gray-800">
      @if (loadingUsers) {
        <div class="flex items-center justify-center p-8 text-sm text-gray-500 dark:text-gray-400">
          Cargando usuarios…
        </div>
      } @else if (filteredUsers.length === 0) {
        <div class="p-8 text-center text-sm text-gray-500 dark:text-gray-400">
          No hay usuarios que coincidan
        </div>
      } @else {
        <ul class="divide-y divide-gray-100 dark:divide-gray-800 max-h-96 overflow-y-auto">
          @for (u of filteredUsers; track u.id) {
            <li class="flex items-center justify-between gap-3 p-3">
              <div class="min-w-0">
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">
                  {{ u.fullname }} {{ u.lastname }}
                </p>
                <p class="truncate text-xs text-gray-500 dark:text-gray-400">
                  {{ u.mail }} · {{ u.roleName }}
                </p>
              </div>
              <button
                type="button"
                [disabled]="saving"
                (click)="assign(u)"
                class="rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-teal-700 disabled:opacity-50"
              >
                Asignar como {{ roleLabel(selectedRole) }}
              </button>
            </li>
          }
        </ul>
      }
    </div>

    <div class="mt-4 flex items-center justify-between">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Re-asignar a un usuario existente actualiza su rol.
      </p>
      <button
        type="button"
        (click)="closeModal()"
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        Cerrar
      </button>
    </div>
  </div>
</app-modal>
